module.exports = __webpack_public_path__ + "static/media/img1.817d102b.jpeg";